import { j as a } from "../../jsx-runtime-B6kdoens.js";
import { c as i } from "../../index-CROKJrb5.js";
import { c as f, f as m } from "../../create-component-CBAeEoQ6.js";
import { u as d, C as l } from "../../CardContext-B6h__heb.js";
const x = i({
  base: "cur-flex cur-flex-col cur-flex-wrap cur-gap-2 cur-p-1",
  variants: {
    surface: {
      transparent: "cur-bg-transaprent cur-p-0",
      white: "cur-bg-surface-neutral"
    }
  }
}), b = f(
  "Card",
  m(
    ({ as: e, children: t, className: s, id: o, surface: c, ...n }, u) => {
      const p = e || "div", [r] = d({
        id: o,
        surface: c
      });
      return /* @__PURE__ */ a.jsx(l.Provider, { value: r, children: /* @__PURE__ */ a.jsx(
        p,
        {
          ref: u,
          className: x({ className: s, ...r }),
          id: r.id,
          ...n,
          children: t
        }
      ) });
    }
  )
);
export {
  b as Card
};
//# sourceMappingURL=index.js.map
